import { Category } from '../types/event-response.type';
import { Breadcrumb } from '../components/breadcrumbs/breadcrumbs.component';
import { getParentCategoriesUtil } from './getParentCategories.util';

export function getCategoryBreadcrumbsUtil(
  categories: Category[],
  targetId: number | null
): Breadcrumb[] {
  if (!targetId) {
    return [];
  }

  const breadcrumbs = [
    { title: 'All Sports', id: null, path: '/browse-categories' },
  ];

  return [
    ...breadcrumbs,
    ...getParentCategoriesUtil(categories, targetId).map((item: Category) => ({
      title: item.category_title,
      id: item.category_id,
      path: `/browse-categories/${item.category_id}`,
    })),
  ];
}
